import { Fragment } from 'react';
import { ErrorOutline, Report, CheckCircle, Verified } from '@mui/icons-material'

import { Text } from '../../FormControls/Text';
import { Input } from '../../FormControls/Input';
import { Stack } from '../../FormControls/Stack';
import { Box } from '../../FormControls/Box';

import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit';
import { setPassword, registerUser, authUser } from '../../../../main/slices/userSlice';

import { ScreenControl } from '../ScreenControl';

export const Password = ({ dimensions }) => {

    const dispatch = useDispatch();

    // Memoized Selectors (Avoid Re renders)
    const getId = (state) => state.id;
    const getCheck = (state) => state.exists;
    const getPassword = (state) => state.password;
    const initState = createSelector([getId, getPassword, getCheck], (id, password, exists) => ({ password, id, exists }))
    // Retrieve state whit Memoized Selectors
    const state = useSelector(({ user }) => initState(user));

    const handleChange = (e) => {

        let checks = {
            uppercase: true,
            number: true,
            symbol: true,
            length: true
        };

        // CHECK FOR UPPERCASE
        if (/[A-Z]/g.test(e)) checks.uppercase = false;
        // CHECK FOR NUMBER
        if (/\d/g.test(e)) checks.number = false;
        // CHECK FOR SYMBOL
        if (/(\.|,|@|\/|#|\*|\+|-|\$|%|&|!|¡|\?|¿)/g.test(e)) checks.symbol = false;
        // CHECK FOR LENGTH
        if (/.{7,}/g.test(e)) checks.length = false;

        // IF THE PASSWORD IS STRONG
        dispatch(setPassword({ value: e, checks, error: Object.values(checks).reduce((a, b) => a || b) }));
    }

    const submitUser = async () => {
        if (!state.exists) {
            if (!state.id) return await dispatch(registerUser())
                .unwrap()
                .then(({ response }) => {
                    if (!response.error) return true;
                    else return false;
                })
                .catch(e => false);

            else return true;
        }
        else return await dispatch(authUser())
            .unwrap()
            .then(({ response }) => {
                if (!response.error) return true;
                return false;
            })
            .catch(e => false);
    }

    return (
        <Fragment>
            <Stack
                sx={{ ...dimensions }}
                flex={{
                    flexDirection: "column",
                    alignContent: "center",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >

                {!state.exists ? <Text classes={["title", "left"]}> Crea tu contraseña </Text>
                    : <Text classes={["title", "left"]}> Ingresa tu contraseña </Text>}

                {/* PASSWORD STRENGTH ALERT */}
                {!state.exists && <Text classes={["description", "alignContent"]} style={{ "justifyContent": "flex-start", "margin": "0.5em 0" }}>
                    {state.password.error ? <><Report sx={{ fontSize: "1em", margin: "0 0.5em", color: "#be123c" }}></Report> Contraseña debil</>
                        : <><Verified sx={{ fontSize: "1em", margin: "0 0.5em", color: "#008000" }}></Verified> Contraseña fuerte</>}
                </Text>}

                {/* INPUT PASSWORD */}
                <Input
                    type="password"
                    placeHolder="Contraseña"
                    attributes={{ value: state.password.value }}
                    onChange={({ target }) => handleChange(target.value)}
                />

                {/* PASSWORD REQUIREMENTS */}
                {!state.exists && <Box classes={["card", "cardShadow", "marginTB1em"]} style={{ backgroundColor: "unset" }}>
                    <Text classes={["subtitle", "center"]} > Verifica que tu contraseña sea fuerte </Text>

                    {/* AT LEAST 1 NUMBER VALIDATION */}
                    <Stack classes={["marginTB05em"]} flex={{ flexDirection: "row", alignItems: "center" }}>
                        {//ICON
                            state.password.checks.number
                                ? <ErrorOutline sx={{ fontSize: "1em", margin: "0 0.5em", color: "#be123c" }}></ErrorOutline>
                                : <CheckCircle sx={{ fontSize: "1em", margin: "0 0.5em", color: "#008000" }}></CheckCircle>
                        }
                        <Text classes={["description"]}> Al menos 1 número. </Text>
                    </Stack>

                    {/* AT LEAST 1 SYMBOL VALIDATION */}
                    <Stack flex={{ flexDirection: "row", alignItems: "center" }}>
                        {//ICON
                            state.password.checks.symbol
                                ? <ErrorOutline sx={{ fontSize: "1em", margin: "0 0.5em", color: "#be123c" }}></ErrorOutline>
                                : <CheckCircle sx={{ fontSize: "1em", margin: "0 0.5em", color: "#008000" }}></CheckCircle>
                        }
                        <Text classes={["description"]}> Al menos 1 símbolo. </Text>
                    </Stack>

                    {/* AT LEAST 6 CHARACTERS VALIDATION */}
                    <Stack classes={["marginTB05em"]} flex={{ flexDirection: "row", alignItems: "center" }}>
                        {//ICON
                            state.password.checks.length
                                ? <ErrorOutline sx={{ fontSize: "1em", margin: "0 0.5em", color: "#be123c" }}></ErrorOutline>
                                : <CheckCircle sx={{ fontSize: "1em", margin: "0 0.5em", color: "#008000" }}></CheckCircle>
                        }
                        <Text classes={["description"]}> Más de 6 caracteres. </Text>
                    </Stack>

                    {/* AT LEAST 1 UPPERCASE VALIDATION */}
                    <Stack flex={{ flexDirection: "row", alignItems: "center" }}>
                        {//ICON
                            state.password.checks.uppercase
                                ? <ErrorOutline sx={{ fontSize: "1em", margin: "0 0.5em", color: "#be123c" }}></ErrorOutline>
                                : <CheckCircle sx={{ fontSize: "1em", margin: "0 0.5em", color: "#008000" }}></CheckCircle>
                        }
                        <Text classes={["description"]}> Al menos 1 mayúscula. </Text>
                    </Stack>
                </Box>}
            </Stack>

            <ScreenControl
                disabled={!state.exists ? state.password.error : state.password.value.length < 6 ? true : false}
                beforeSubmit={() => submitUser()}
            >
            </ScreenControl>
        </Fragment >
    );
}